(function () {
  'use strict';

  /* =========================================================
     CONFIG
  ========================================================= */

  /*
   * Same BlueStar detection logic used
   * in the previous BPG delivery module.
   */
  const BLUE_STAR_VENDORS = [
    'blue star'
  ];

  let refreshTimer = null;
  let latestCart = null;
  let cartRequest = null;


  /* =========================================================
     CART API
  ========================================================= */

  async function getCart() {

    if (cartRequest) {
      return cartRequest;
    }

    cartRequest =
      fetch(
        '/cart.js',
        {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: {
            Accept: 'application/json'
          }
        }
      )
        .then(function (response) {

          if (!response.ok) {
            throw new Error(
              'Unable to read cart.'
            );
          }

          return response.json();
        })
        .finally(function () {

          cartRequest = null;

        });

    return cartRequest;
  }


  /* =========================================================
     BLUE STAR HELPERS
  ========================================================= */

  function normalizeVendor(value) {

    return String(value || '')
      .trim()
      .toLowerCase();
  }


  function isBlueStarItem(item) {

    return BLUE_STAR_VENDORS.includes(
      normalizeVendor(
        item && item.vendor
      )
    );
  }


  /*
   * IMPORTANT:
   *
   * This intentionally uses .some().
   *
   * BlueStar only cart:
   *   blocked
   *
   * BlueStar + normal mixed cart:
   *   also blocked
   */
  function cartHasBlueStar(cart) {

    if (
      !cart ||
      !Array.isArray(cart.items)
    ) {
      return false;
    }

    return cart.items.some(
      function (item) {

        return isBlueStarItem(
          item
        );

      }
    );
  }


  /* =========================================================
     KITE BUTTON HELPERS
  ========================================================= */

  function getKiteMethodButtons() {

    const buttons =
      Array.from(
        document.querySelectorAll(
          '.kite-method-btn'
        )
      );

    let localDeliveryButton = null;
    let shippingButton = null;

    buttons.forEach(
      function (button) {

        const label =
          String(
            button.textContent || ''
          )
            .trim()
            .toLowerCase();


        if (
          label === 'local delivery' ||
          label.includes(
            'local delivery'
          )
        ) {

          localDeliveryButton =
            button;
        }


        if (
          label === 'shipping'
        ) {

          shippingButton =
            button;
        }
      }
    );


    return {
      localDeliveryButton:
        localDeliveryButton,

      shippingButton:
        shippingButton
    };
  }


  /* =========================================================
     NOTICE
  ========================================================= */

  function removeBlueStarNotice() {

    document
      .querySelectorAll(
        '[data-bpg-bluestar-delivery-notice]'
      )
      .forEach(
        function (element) {

          element.remove();

        }
      );
  }


  function showBlueStarNotice() {

    /*
     * Never create duplicates.
     */
    if (
      document.querySelector(
        '[data-bpg-bluestar-delivery-notice]'
      )
    ) {
      return;
    }


    const methodTabs =
      document.querySelector(
        '.kite-method-tabs'
      );


    if (!methodTabs) {
      return;
    }


    const notice =
      document.createElement(
        'div'
      );


    notice.setAttribute(
      'data-bpg-bluestar-delivery-notice',
      'true'
    );


    /*
     * Reuse existing BPG notice styling.
     */
    notice.className =
      'bpg-bulk-handling-notice';


    notice.innerHTML = `
      <strong>
        Free Local Delivery Not Available
      </strong>

      <p>
        BlueStar products are excluded from the
        free local delivery offer.
        Please select Shipping to continue.
      </p>
    `;


    /*
     * Insert immediately after
     * Local Delivery / Shipping tabs.
     */
    methodTabs.insertAdjacentElement(
      'afterend',
      notice
    );
  }


  /* =========================================================
     RESTORE NORMAL LOCAL DELIVERY
  ========================================================= */

  function restoreLocalDeliveryButton(
    button
  ) {

    if (!button) {
      return;
    }


    button.hidden = false;

    button.disabled = false;

    button.removeAttribute(
      'aria-disabled'
    );

    button.removeAttribute(
      'data-bpg-bluestar-blocked'
    );

    button.style.removeProperty(
      'display'
    );
  }


  /* =========================================================
     BLOCK LOCAL DELIVERY
  ========================================================= */

  function blockLocalDeliveryButton(
    button
  ) {

    if (!button) {
      return;
    }


    /*
     * Completely hide Local Delivery.
     *
     * Customer only sees Shipping.
     */
    button.hidden = true;

    button.disabled = true;

    button.setAttribute(
      'aria-disabled',
      'true'
    );

    button.setAttribute(
      'data-bpg-bluestar-blocked',
      'true'
    );

    button.style.display =
      'none';
  }


  /* =========================================================
     APPLY BLUE STAR RULE
  ========================================================= */

  function applyBlueStarDeliveryRule(
    cart
  ) {

    latestCart = cart;


    const hasBlueStar =
      cartHasBlueStar(
        cart
      );


    const methods =
      getKiteMethodButtons();


    /*
     * No BlueStar products:
     *
     * Don't interfere with existing
     * $50 / 20km delivery rules.
     */
    if (!hasBlueStar) {

      restoreLocalDeliveryButton(
        methods.localDeliveryButton
      );

      removeBlueStarNotice();

      document.documentElement
        .removeAttribute(
          'data-bpg-bluestar-delivery-excluded'
        );

      return;
    }


    /*
     * BlueStar-only OR mixed cart:
     *
     * Free Local Delivery is unavailable.
     */

    document.documentElement
      .setAttribute(
        'data-bpg-bluestar-delivery-excluded',
        'true'
      );


    blockLocalDeliveryButton(
      methods.localDeliveryButton
    );


    /*
     * If Local Delivery happened to be selected
     * before a BlueStar item was added,
     * force the cart back to Shipping.
     */
    if (
      methods.shippingButton &&
      methods.shippingButton
        .getAttribute(
          'aria-pressed'
        ) !== 'true'
    ) {

      methods.shippingButton.click();
    }


    showBlueStarNotice();


    console.log(
      '[BPG BlueStar] Free local delivery excluded.',
      {
        mixedCart:
          cart.items.some(
            function (item) {
              return !isBlueStarItem(item);
            }
          ),

        blueStarItems:
          cart.items.filter(
            isBlueStarItem
          ).map(
            function (item) {

              return (
                item.product_title ||
                item.title
              );
            }
          )
      }
    );
  }


  /* =========================================================
     REFRESH
  ========================================================= */

  async function refreshBlueStarRule() {

    try {

      const cart =
        await getCart();


      applyBlueStarDeliveryRule(
        cart
      );


    } catch (error) {

      console.warn(
        '[BPG BlueStar] Unable to check cart:',
        error
      );

    }
  }


  function scheduleRefresh(
    delay
  ) {

    clearTimeout(
      refreshTimer
    );


    refreshTimer =
      setTimeout(
        refreshBlueStarRule,
        typeof delay === 'number'
          ? delay
          : 300
      );
  }


  /* =========================================================
     SAFETY — BLOCK LOCAL DELIVERY CLICK
  ========================================================= */

  document.addEventListener(
    'click',
    function (event) {

      const button =
        event.target &&
        event.target.closest
          ? event.target.closest(
              '.kite-method-btn'
            )
          : null;


      if (!button) {
        return;
      }


      const label =
        String(
          button.textContent || ''
        )
          .trim()
          .toLowerCase();


      if (
        label !== 'local delivery' &&
        !label.includes(
          'local delivery'
        )
      ) {
        return;
      }


      if (
        latestCart &&
        cartHasBlueStar(
          latestCart
        )
      ) {

        event.preventDefault();

        event.stopPropagation();

        event.stopImmediatePropagation();


        const methods =
          getKiteMethodButtons();


        blockLocalDeliveryButton(
          button
        );


        if (
          methods.shippingButton &&
          methods.shippingButton
            .getAttribute(
              'aria-pressed'
            ) !== 'true'
        ) {

          methods.shippingButton.click();
        }


        showBlueStarNotice();
      }

    },
    true
  );


  /* =========================================================
     SHOPIFY CART EVENTS
  ========================================================= */

  [
    'cart:updated',
    'cart:refresh',
    'cart:change',
    'shopify:section:load'
  ].forEach(
    function (eventName) {

      document.addEventListener(
        eventName,
        function () {

          scheduleRefresh(
            250
          );

        }
      );

    }
  );


  /* =========================================================
     DETECT AJAX CART CHANGES
  ========================================================= */

  const originalFetch =
    window.fetch;


  window.fetch =
    async function () {

      const response =
        await originalFetch.apply(
          this,
          arguments
        );


      try {

        const request =
          arguments[0];


        const url =
          typeof request === 'string'
            ? request
            : (
                request &&
                request.url
                  ? request.url
                  : ''
              );


        if (
          url &&
          (
            url.includes(
              '/cart/add'
            ) ||
            url.includes(
              '/cart/change'
            ) ||
            url.includes(
              '/cart/update'
            ) ||
            url.includes(
              '/cart/clear'
            )
          )
        ) {

          scheduleRefresh(
            400
          );
        }

      } catch (error) {

        /*
         * Ignore URL detection errors.
         */

      }


      return response;
    };


  /* =========================================================
     KITE UI OBSERVER
  ========================================================= */

  const observer =
    new MutationObserver(
      function () {

        /*
         * Kite may render its tabs after
         * our JS initially runs.
         */

        if (latestCart) {

          applyBlueStarDeliveryRule(
            latestCart
          );

        } else {

          scheduleRefresh(
            100
          );

        }
      }
    );


  /* =========================================================
     INITIALIZE
  ========================================================= */

  function initialize() {

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );


    refreshBlueStarRule();
  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      {
        once: true
      }
    );

  } else {

    initialize();
  }

})();